<template>
  <div class="wrap">
	<div class="type">
		<ul>
			<li :class="{active:index==i}" v-for="(v,i) in typeList" :key="i" @click="typeChange(v,i)">{{v.name}}</li>
		</ul>
	</div>
    <div id="sortCount"></div>
  </div>
</template>

<script>
import {
  selectUserDocList,
} from "@/network/other/sortCount";
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
  name: "versionManage",
  mixins: [mixins],
  data() {
    return {
	  index:0,
      timeResize: null,
	  typeList:[
		  {type:1,name:"当天"},
		  {type:2,name:"一周内"},
		  {type:3,name:"一个月"},
		  {type:4,name:"历史"}
		  ]
    };
  },
  created() {
  	
  },
  mounted() {
  	if (this.myChart) {
  		this.myChart.dispose()
  	} //销毁上一次的图
  	this.myChart = this.$init(document.getElementById("sortCount")); //创建实例
  	window.addEventListener("resize", this.resetResize);
	this.getInitEchart();
  },
  methods: {
   getInitData(type=4) {
      selectUserDocList({type:type}).then(res=>{
		let xdata = [];
		let ydata = [];
		let data = res.data;
		if (data.code == 200) {
			data.data.forEach((v,i)=>{
				xdata.push(v.userZh);
				ydata.push(v.count)
			})
		}
		this.myChart.setOption({
			xAxis:{data: xdata},
			series:[{ data: ydata}]
		})
	  });
		
    },
	getInitEchart(){
		let option = {
			  backgroundColor: '#fff',
			  tooltip: {
				  trigger: 'axis',
				  axisPointer: {
					  type: 'cross',
					  crossStyle: {
						  color: '#999'
					  },
					  lineStyle: {
						  type: 'dashed'
					  }
				  }
			  },
			  grid: {
				  left: '30',
				  right: '30',
				  bottom: '30',
				  top: '30',
				  containLabel: true
			  },
			  yAxis: {
			          type: 'value',
			          axisLabel: {
			              color: '#999',
			              textStyle: {
			                  fontSize: 12
			              },
			          },
			          splitLine: {
			              show: true,
			              lineStyle: {
			                  color: '#F3F4F4'
			              }
			          },
			          axisTick: {
			              show: false
			          },
			          axisLine: {
			              show: false
			          },
			      },
			 xAxis: {
			    type: 'category',
			    data: []
			  },
			  yAxis: {
			    type: 'value'
			  },
			  series: [
			    {
				  name:"文章数",
			      data: [],
			      type: 'line'
			    }
			  ]
		};
		this.myChart.setOption(option);
	},
	resetResize() {
		if (this.timeResize) {
			clearTimeout(this.timeResize);
			this.timeResize = null
		}
		this.timeResize = setTimeout(res => {
			this.myChart.resize(); //重新绘制图表
	
		}, 200)
	
	},
	typeChange(v,i){
		this.index = i;
		this.getInitData(v.type);
	}
  },
  beforeDestroy() {
  	if (this.myChart) {
  		this.myChart.dispose()
  	} //销毁上一次的图
  	if (this.timeResize) {
  		clearTimeout(this.timeResize)
  	};
  	window.removeEventListener('resize', this.resetResize); //离开页面销毁监听事件
  },
};
</script>

<style scoped lang="scss">
.wrap{
	display: flex;
	flex-direction: column;
	#sortCount{
		flex: 1;
	}
	.type {
		display: flex;
		background-color: #fff;
		ul{
			li{
				list-style: none;
				width: 80px;
				padding: 8px;
				text-align: center;
				display: inline-block;
				border: 1px solid #ddd;
				font-size: 12px;
				border-right: 0px;
				cursor: pointer;
			}
			.active{
				background-color: #4C96F1;
				color: #fff;
				font-weight: bold;
				font-size: 14px;
			}
			&:last-child{
				border-right: 1px solid #ddd;
			}
		}
		
	}
}

</style>